import { render, staticRenderFns } from "./AccountDashboard.vue?vue&type=template&id=d97d86be&"
import script from "./AccountDashboard.vue?vue&type=script&lang=js&"
export * from "./AccountDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports